import { Platform } from 'react-native'
import { Stack } from 'expo-router'
import {
  platformStackAnimation,
  stableStackOptions,
} from '../../../lib/navigation/stable-stack-options'

// Web is a single-page app with no native push/pop chrome — any animation
// other than `none` produces visible flicker on hydration. Native gets the
// platform default (slide_from_right on iOS, fade on Android) plus the
// per-screen overrides below for intentional context signaling.
const webNoAnim = Platform.OS === 'web' ? stableStackOptions : {}

export default function ExploreLayout() {
  return (
    <Stack screenOptions={{ headerShown: false, ...stableStackOptions, ...webNoAnim }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="all-vehicles" />
      <Stack.Screen name="map" />
      {/* Vehicle detail emerges from the bottom (modal-like reveal) — signals
          "you're zooming into one item" rather than "you moved laterally".
          Mirrors the App Store / Apple Photos detail-page pattern. */}
      <Stack.Screen
        name="[vehicleId]"
        options={{ animation: platformStackAnimation('fade_from_bottom') }}
      />
    </Stack>
  )
}
